let scroll = new SmoothScroll('a[href*="#"]', {
	speed: 300,
	speedAsDuration: true,
	offset: $(".navbar__list-wrap").innerHeight()
});
